import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../elements/Button';
import Icon from './Icon';

const ContactPersonNotice = ({ userInfo, messageKey = 'contactPersonNoticeTitle' }) => {
  const { t } = useTranslation();

  if (userInfo?.role !== 'contactPerson') return null;

  return (
    <div className="text-center mx-3 mb-3">
      <div className="mb-3">
        <Icon name="triangle-warning" theme="warning" className="me-2" />
        <strong>{t(messageKey)}</strong>
      </div>
      <Button to="/role" theme="light" mb="0" styles={{}} p="2" className="px-3">
        <Icon name="running" theme="primary" className="me-2" />
        {t('switchToPlayer')}
      </Button>
    </div>
  );
};

export default ContactPersonNotice;
